import React from 'react';
import { Pagination, Row, Col, DatePicker, Button, Input } from 'antd';
import TableComponent from 'components/table-component';
import { DATE_FORMAT } from 'constants/app-constants';
import moment from 'moment';
import ExcelDownload from 'components/excel-download';
import { AiOutlineSearch } from 'react-icons/ai';

const { RangePicker } = DatePicker;

const DispatchReportListPresentational = ({
	column,
	tableData,
	handleTableChange,
	getStartingValue,
	getEndingValue,
	pageSize,
	intialPageSizeOptions,
	initialPageSize,
	currentPage,
	tableLoading,
	exportData,
	handleDateChange,
	getDispatchReportList,
	filterOptions, 
	setFilterOptions,
}) => {
	return (
		<Row style={{ padding: '20px 10px' }}>
			<Col xl={24} md={24}>
				<TableComponent
					loading={tableLoading}
					className="custom-table"
					style={{ width: '100%' }}
					rowKey={(record) => record._id}
					dataSource={tableData}
					title={() => (
						<Row justify="space-between">
							<Col xl={24} md={24}>
								<Row gutter={[10, 10]} style={{ width: '100%' }}>
									<Col xl={5} md={5}>
										<Input
											placeholder="Search Vendor"
											suffix={<AiOutlineSearch />}
											allowClear
											style={{ height: '30px' }}
											onChange={({ target: { value } }) => setFilterOptions({ ...filterOptions, searchKey: value })}
										/>
									</Col>
									<Col xl={8} md={8}>
										<RangePicker
											placeholder={['Select From Date', 'Select To Date']}
											style={{ width: '100%' }}
											format={DATE_FORMAT.DD_MM_YYYY}
											onChange={handleDateChange} // Use handleDateChange here
											value={[
												moment(filterOptions.fromDate, DATE_FORMAT.YYYY_MM_DD),
												moment(filterOptions.toDate, DATE_FORMAT.YYYY_MM_DD),
											]} // Ensure the current dates are selected
										/>
									</Col>
								</Row>
							</Col>
							<Col xl={24} md={24} style={{ paddingTop: 10 }}>
								<Row gutter={[10, 10]}>
									<Col xl={4} md={4}>
										<Button onClick={getDispatchReportList} style={{ width: '100%' }} type="primary">
											Submit
										</Button>
									</Col>
									<Col xl={4} md={4}>
										<ExcelDownload {...{ ...exportData }} />
									</Col>
								</Row>
							</Col>
						</Row>
					)}
					{...{
						columns: column,
						pagination: { current: currentPage, pageSize: pageSize, position: ['none', 'none'] },
						...(!!tableData?.length && {
							footer: () => (
								<Row justify="space-between">
									<Col span={12}>
										{!!tableData?.length && `Showing ${getStartingValue()} - ${getEndingValue()} of ${tableData?.length} Data`}
									</Col>
									<Col span={12}>
										<div style={{ textAlign: 'right' }}>
											<Pagination
												current={currentPage}
												pageSizeOptions={intialPageSizeOptions}
												defaultPageSize={initialPageSize}
												showSizeChanger={true}
												total={tableData?.length}
												onChange={handleTableChange}
												responsive
											/>
										</div>
									</Col>
								</Row>
							),
						}),
					}}
				/>
			</Col>
		</Row>
	);
};

export default DispatchReportListPresentational;
